/**
 * Warm the lazy chunks for the most common protected destinations once the
 * session is authenticated, so React.lazy resolves them instantly on
 * navigation and the route-chunk Suspense fallback (RouteFallback ring) does
 * not fire post-login. Side-effect-only: it primes the module cache; it does
 * NOT render, route, or fetch data.
 *
 * See docs/ux/2026-07-02-auth-transition-microstates.md §9 lever (b).
 */
let started = false

export function prefetchProtectedRouteChunks(): void {
  // Idempotent: the module cache is warmed at most once per session load.
  if (started) return
  started = true
  // Fire-and-forget. A failed import is irrelevant here — the real
  // navigation re-triggers it through React.lazy — so swallow rejections.
  // The wordmark leads to `/`, which is the personal home once signed in (home split).
  void import('@/pages/me/home/Page').catch(() => {})
  void import('@/pages/profile/Page').catch(() => {})
  void import('@/pages/workspace/Page').catch(() => {})
  // The login-landing rule sends a 1-managed-club user straight to their club,
  // so warm the organization chunk too — otherwise the RouteFallback ring flashes
  // full-screen before the club's own "Loading your club…" ring (double loader).
  void import('@/pages/organization/Page').catch(() => {})
}
